import React from 'react';
import styles from './PaymentInvoices.module.css';
import {
  fmtNum,
  fmtCurr,
  fmtDateShort,
  STATUS_TAG,
  STATUS_LABEL,
} from './helpers';

const InvoiceTableRow = ({
  invoice,
  selected,
  onSelect,
  onView,
  onViewFull,
  onDownloadClick,
  onStatusClick,
}) => {
  const tagClass = styles[STATUS_TAG[invoice.status]] || styles.tagGy;
  const label = STATUS_LABEL[invoice.status] || invoice.status;

  return (
    <div
      className={`${styles.tblRow} ${styles.tblColGrid}`}
      onClick={() => onView(invoice)}
    >
      <input
        type="checkbox"
        className={styles.cb}
        checked={selected}
        onChange={e => onSelect(invoice.companyInvoiceId, e.target.checked)}
        onClick={e => e.stopPropagation()}
      />

      <div>
        <div className={styles.invNum}>{invoice.invoiceNumber}</div>
        <div className={styles.invDue}>
          Due: {invoice.paymentDate ? fmtDateShort(invoice.paymentDate) : '—'}
        </div>
      </div>

      <div>
        <div className={styles.rowPlaceName}>{invoice.company?.name ?? '—'}</div>
        <div className={styles.rowCompany}>
          {[invoice.company?.city, invoice.company?.state].filter(Boolean).join(', ')}
        </div>
      </div>

      <div>
        <div className={styles.rowPlaceName}>
          {invoice.places?.[0]?.name ?? '—'}
        </div>
        {invoice.places?.length > 1 && (
          <div className={styles.rowCompany}>+{invoice.places.length - 1} more</div>
        )}
      </div>

      <div className={styles.rowPeriod}>
        {fmtDateShort(invoice.period?.from)}
        <br />
        <span className={styles.rowPeriodTo}>
          → {fmtDateShort(invoice.period?.to)}
        </span>
      </div>

      <div className={styles.rowOrders}>{fmtNum(invoice.orderCount)}</div>
      <div className={styles.rowSaleValue}>{fmtCurr(invoice.saleValue)}</div>

      <div>
        <div className={styles.rowFeeValue}>{fmtCurr(invoice.kraveinFee)}</div>
      </div>

      <div className={styles.rowNetPayout}>{fmtCurr(invoice.netPayout)}</div>

      <span className={`${styles.tag} ${tagClass}`}>{label}</span>

      <div className={styles.rowActions} onClick={e => e.stopPropagation()}>
        <button
          className={`${styles.btn} ${styles.btnIcon} ${styles.btnSm}`}
          title="View"
          onClick={() => onViewFull(invoice)}
        >
          👁
        </button>
        <button
          className={`${styles.btn} ${styles.btnIcon} ${styles.btnSm}`}
          title="Download"
          onClick={() => onDownloadClick(invoice)}
        >
          ⬇
        </button>
        <button
          className={`${styles.btn} ${styles.btnIcon} ${styles.btnSm}`}
          title="Change Status"
          onClick={() => onStatusClick(invoice)}
        >
          ✎
        </button>
      </div>
    </div>
  );
};

export default InvoiceTableRow;
